import { http } from "../client";
import qs from "query-string";
var URL = "clients";
var getMany = function (_a) {
    var take = _a.take, username = _a.username, russianLegalEntityTitle = _a.russianLegalEntityTitle, skip = _a.skip, orderByDirection = _a.orderByDirection, orderBy = _a.orderBy;
    return http.api
        .get(URL, {
        params: {
            take: take,
            skip: skip,
            username: username,
            russian_legal_entity_title: russianLegalEntityTitle,
            orderBy: orderBy,
            orderByDirection: orderByDirection,
        },
        paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: "comma", skipEmptyString: true });
        },
    })
        .then(function (_a) {
        var _b = _a.data.data, total = _b.total, skip = _b.skip, take = _b.take, items = _b.items;
        return ({
            total: total,
            skip: skip,
            take: take,
            items: items,
        });
    });
};
var create = function (request) {
    return http.api.post(URL, { user: request });
};
var getOne = function (id) {
    return http.api
        .get("".concat(URL, "/").concat(id))
        .then(function (res) { return res.data.data; });
};
export var clientsApi = {
    getMany: getMany,
    create: create,
    getOne: getOne,
};
